/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';

const base = (state) => state.clientInfo;

export const makeSelectOpenState = () => createSelector(
  [base], (clientInfo) => clientInfo.isOpen,
);

export const makeSelectLoaderState = () => createSelector(
  [base], (clientInfo) => clientInfo.loading,
);

export const makeSelectClientCode = () => createSelector(
  [base], (clientInfo) => clientInfo.clientCode,
);
export const makeSelectClientCodeEditMode = () => createSelector(
  [base], ({ clientCode, editMode, noteId }) => ({ id: clientCode, editMode, noteId }),
);

export const makeSelectClientNote = () => createSelector(
  [base], ({ noteId }) => noteId,
);
